// extracted by mini-css-extract-plugin
module.exports = {"breadCrumbs":"ContactsPage_breadCrumbs__3D_tK","section":"ContactsPage_section__LRxha","load":"ContactsPage_load__oX3gh"};